import { render, staticRenderFns } from "./vFormImageDixCell.vue?vue&type=template&id=e0afc4ea&scoped=true&"
import script from "./vFormImageDixCell.vue?vue&type=script&lang=js&"
export * from "./vFormImageDixCell.vue?vue&type=script&lang=js&"
import style0 from "./vFormImageDixCell.vue?vue&type=style&index=0&id=e0afc4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0afc4ea",
  null
  
)

export default component.exports